import { createWebHistory, createRouter } from "vue-router";
import axios from "axios";
import routes from "./routes";
import appConfig from "../../app.config";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.withCredentials = true;

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const authRequired = to.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  // Check if token exists
  const token = sessionStorage.getItem("auth.token");
  if (!token) {
    sessionStorage.removeItem("auth.currentUser");
    sessionStorage.removeItem("auth.token");
    sessionStorage.removeItem("app_url");
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  try {
    const response = await axios.get("/me");
    
    if (response.data.valid) {
      localStorage.setItem("user", JSON.stringify(response.data));
      next();
    } else {
      // Token is invalid
      sessionStorage.removeItem("auth.currentUser");
      sessionStorage.removeItem("auth.token");
      sessionStorage.removeItem("app_url");
      localStorage.removeItem("user");
      next({ name: "login", query: { redirect: to.fullPath } });
    }
  } catch (error) {
    // Handle token expiration or other auth errors
    const message = error.response?.data?.message;
    
    if (message === 'TOKEN_EXPIRED' || message === 'INVALID_TOKEN' || message === 'NO_TOKEN') {
      console.warn('Authentication failed:', message);
    }
    
    // Clear all auth data
    sessionStorage.removeItem("auth.currentUser");
    sessionStorage.removeItem("auth.token");
    sessionStorage.removeItem("app_url");
    localStorage.removeItem("user");
    
    next({ name: "login", query: { redirect: to.fullPath } });
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + " | " + appConfig.title;

  next();
});

export default router;
